const ConfirmRemoval = {
  methods: {
    confirmRemoval: function(options = {}, okFn = () => {}, cancelFn = () => {}) {
      const { message: optionsMessage, id, ...rest } = options
      const message = optionsMessage || `Are you sure you want to remove ${id ? `"${id}"` : 'this item'}?`

      return this.$bvModal.msgBoxConfirm(message, rest)
        .then((v) => v ? okFn(v) : cancelFn())
        .catch(cancelFn)
    },
  },
}


export default ConfirmRemoval
